import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { AptSearchTextBox } from "src/components/apt-search-textbox";
import { DataRanges } from "src/utils/configs";
import { paths } from "src/paths";

import { useAuth } from "src/hooks/use-auth";
import { useSubscriptionExpired } from "src/hooks/use-subscription-expired";
import { subscriptionPolicy } from "src/configs/subscription-access";

export const HeaderPropertySearch = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const expired = useSubscriptionExpired(user);
  return (
    <Box sx={{ width: { xs: 90, sm: 120 }, minWidth: 60, flexShrink: 1 }}>
      <AptSearchTextBox
        width="100%"
        placeholder="지역·아파트 검색..."
        dataRange={DataRanges.SPYEONG}
        regionSearchProps={{
          onRegionSelect: (region) => {
            const params = new URLSearchParams({ regionId: region.id, dataRange: region.dataRange });
            navigate(`${paths.dashboard.mregion.analyze}?${params}`);
          },
        }}
        onAptSelect={(apt) => {
          if (expired && subscriptionPolicy.freeScreensEnabled) {
            const params = new URLSearchParams({ id: apt.aptId });
            if (apt.pyeongId) params.set("pyeongId", apt.pyeongId);
            navigate(`${paths.dashboard.apts.newwindow}?${params}`);
            return;
          }
          const params = new URLSearchParams({ aptId: apt.aptId, pyeongId: apt.pyeongId, view: "detail" });
          navigate(`${paths.dashboard.apts.selectmap}?${params}`);
        }}
      />
    </Box>
  );
};
